import { useState } from "react";
import { properties, atribInputDialog } from "./smsSignData";
import useFirmaFunctions from "components/pages/firmaSolicitud/FirmaSolicitudFunction";
import RestProvider from "providers/RestProvider";
import { useSelector } from "react-redux";

const useSmsSignFunction = () => {

    const { crudOperation, crudOperationsType } = RestProvider();

    const solicitudActual = useSelector((state) => state.kingdomOV3.solicitudActual);
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    

    const [codigoSms, setCodigoSms] = useState(null);
    const [codigoValido, setCodigoValido] = useState(false);
    const [mostrarDialogo, setMostrarDialogo] = useState(false);
    const { setMsgErrorPresentacion } = useFirmaFunctions();

    const [message, setMessage] = useState({ msg: "", severity: "" });
    let _ID = 0;
    const addAlert = msg => setAlerts([...alerts, { id: _ID++, msg }]);
    const [alerts, setAlerts] = useState([]);

    /**
     * @function handleSetMessage Gestiona los mensajes de por pantalla para errores, info, etc
     */
    const handleSetMessage = (msg, severity) => {
        setMessage({ msg, severity });
        addAlert(message);
    }

    /**
     * @function handleShowDialogo Función encargada de mostrar el cuadro de diálogo
     */
    const handleShowDialogo = () => {
        setMostrarDialogo(true);
    }

    /**
     * @function handleHideDialogo Función encargada de ocultar el cuadro de diálogo
     */
    const handleHideDialogo = () => {
        setCodigoSms('');
        setMostrarDialogo(false);
    }

    /**
     * @function enviarCodigoSms Función encargada de enviar el código sms al ciudadano
     */
    const enviarCodigoSms = async () => {
        let tlfMovil = null;
        let res = null;

        // Se reinicia el valor de la hook que indica si el código insertado por el usuario es válido
        setCodigoValido(false);

        // Paso 1. Obtención del número de teléfono móvil del usuario logado
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATOS_CONTACTO, { url: properties.URL_TLF_MOVIL + infoUsuario.interesadoNif, method: 'get' }).then(response => {
            tlfMovil = response.data;
        }).catch(function (error) {
            setMsgErrorPresentacion(error.response.data);
        });
        // Paso 2. Si se obtiene el número de teléfono móvil, se procede a enviar el código sms al ciudadano
        if (tlfMovil != null) {

            // Paso 2.1. Generación del DTO necesario para el endPoint de envío de sms
            let input = {
                idExpediente: solicitudActual.id === undefined ? solicitudActual.idExpediente : solicitudActual.id,
                nombre: infoUsuario.interesadoNombre,
                apellido1: infoUsuario.interesadoApellido1,
                apellido2: infoUsuario.interesadoApellido2,
                nifNiePasaporte: infoUsuario.interesadoNif,
                destino: tlfMovil
            }

            // Paso 2.2. Envío del código sms al ciudadano
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_SMS, { url: properties.URL_ENVIAR_SMS, method: 'post', data: input }).then(response => {
                res = response.data;
                handleShowDialogo();
            }).catch(function (error) {
                handleSetMessage('Se ha producido un error durante el envío del sms', "error");
            });
        }
        return res;
    }

    const handleChangeDialogo = (e) => {
        setCodigoSms(e.target.value);
    }

    /**
     * @function validarCodigoSms Función que evalúa si el código sms que ha insertado el usuario es el que ha recibido,
     * si es correcto realiza la presentación del expediente utilizando la firma sms
     * @param {*} e 
     * @returns 
     */
    const validarCodigoSms = async (tipoProcEntrega, docsAfirmar) => {
        let res = false;
        let idExp = solicitudActual.id === undefined ? solicitudActual.idExpediente : solicitudActual.id;

        // Comprobación del código insertado
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_SMS, { url: properties.URL_COMPROBAR_CODIGO + codigoSms + `/${idExp}`, method: 'get' }).then(response => {
            // Paso 1. Se obtiene el objeto de respuesta
            res = true;

            // Paso 2. Se oculta el cuadro de diálogo
            handleHideDialogo();

        }).catch(function (error) {
            let msg = `El código ${codigoSms} es erróneo para esta solicitud`;
            let codError = 'error';
            handleSetMessage(msg, codError);
        });
        setCodigoValido(res);
    }

    return { handleChangeDialogo, handleHideDialogo, handleShowDialogo, enviarCodigoSms, validarCodigoSms, mostrarDialogo, codigoSms, atribInputDialog, codigoValido, setCodigoValido };
}

export default useSmsSignFunction;